import * as t from "io-ts";
import { Metadata } from "./Metadata";
import { Pence } from "./Pence";
import { RedirectURLs } from "./RedirectURLs";
import { WorkType } from "./WorkType";

export const InfoLegacyRedirect = t.intersection([
  t.type({
    reference: t.string,
    price: Pence,
    email: t.string,
    description_of_goods: t.string,
    enterprise_id: t.string,
  }),
  t.partial({
    id: t.string,
    cid: t.string,
    oid: t.string,
    aid: t.string,
    eid: t.string,
    bid: t.string,
    tid: t.string,
    first_name: t.string,
    last_name: t.string,
    mobile: t.string,
    deposit: Pence,
    redirect_urls: RedirectURLs,
    enabled_rates: t.array(t.string),
    work_type: WorkType,
    metadata: Metadata,
  }),
]);

export interface InfoLegacyRedirect {
  id?: string;
  cid?: string;
  oid?: string;
  aid?: string;
  eid?: string;
  bid?: string;
  tid?: string;
  reference: string;
  price: Pence;
  email: string;
  description_of_goods: string;
  enterprise_id: string;
  first_name?: string;
  last_name?: string;
  mobile?: string;
  deposit?: Pence;
  redirect_urls?: RedirectURLs;
  enabled_rates?: Array<string>;
  work_type?: WorkType;
  metadata?: Metadata;
}
